/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';

import type { Comment } from '../../../app/entities/comment';

export type CommentContextProps = {
  commentsListRef?: React.RefObject<HTMLDivElement | null>;
  playerRef?: React.RefObject<HTMLVideoElement | null>;
  comments: Comment[];
  selectComment: (comment?: Comment) => void;
  selectedComment?: Comment;
  addComment: (comment: Comment) => void;
  deleteComment: (id: string) => void;
  updateComment: (comment: Comment) => void;
  pdfCurrentPage: number;
  setPdfCurrentPage?: React.Dispatch<React.SetStateAction<number>>;
};

export const CommentContext = React.createContext<CommentContextProps>({
  comments: [],
  addComment: () => {},
  deleteComment: () => {},
  updateComment: () => {},
  selectComment: () => {},
  pdfCurrentPage: 0,
});
